<template>
  <div id="StudyAdvertising" class="study">
    <div class="container-fluid head" style="background-color: #46478A">
      <Header />

      <h1>Advertising</h1>
    </div>

    <div class="container">

      <div class="row">
        <div class="col-12 text-center">
          <h2>The Project</h2>
          <p>
            Various social media posts and ads for different platforms.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6">
          <img src="/images/Advertising/Advertising 1.webp" width="100%" />
        </div>
        <div class="col-12 col-md-6">
          <img src="/images/Advertising/Advertising 2.webp" width="100%" />
        </div>
      </div>


      <div class="row">
        <div class="col-12">
          <h2>Instagram Posts</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <img src="/images/Advertising/Advertising 3.webp" width="100%" />
        </div>
        <div class="col-12 col-md-6">
          <img src="/images/Advertising/Advertising 4.webp" width="100%" /><br/><br/>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <img src="/images/Advertising/Advertising 5.webp" width="100%" />
        </div>
        <div class="col-12 col-md-6">
          <img src="/images/Advertising/Advertising 6.webp" width="100%" /><br/><br/>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <h2>Website</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <img src="/images/Advertising/Advertising 7.webp" width="100%" /><br/><br/>
        </div>
      </div>

    </div>
    <Footer />

  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
export default {
  name: "StudyAdvertising",
  components: { Header, Footer },
  data: function () {
    return {
      slides: [],
    };
  },
  methods: {},
  mounted: function () { },
};
</script>

<style lang="scss">
#StudyAdvertising {
  h2 {
    color: #46478A;
  }
}
</style>